import { render, staticRenderFns } from "./SmsIncomingTariff.vue?vue&type=template&id=651a5a70&"
import script from "./SmsIncomingTariff.vue?vue&type=script&lang=ts&"
export * from "./SmsIncomingTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports